import Cookies from 'js-cookie'
import stock_lookup from "../../api/tyres/_stock-check.js";
import {open_enquire} from "../tyres/_enquire.js";
import {toggle_loader, disable_loader} from '../_loader';

export function get_cart() {
	let cart = Cookies.get('bt_cart');

	//if we have an active cart session
	if(cart) {

		//parse it from JSON
		cart = JSON.parse(cart);
	} else { //if we don't have an active cart session

		//create a new empty one
		Cookies.set('bt_cart', JSON.stringify({
			'tyres': {},
			'addons': {}
		}), { expires: 1 });
		cart = {};
	}

	return cart;
}

export function clear_cart() {
	let cart = get_cart();

	//empty the tyres
	cart['tyres'] = {};
	cart['addons'] = {};

	//update the cart with the new value
	Cookies.set('bt_cart', JSON.stringify(cart), { expires: 1 });
}

export async function update_cart(id, quantity, type = 'tyres', cart = get_cart()) {

    //this will be set to true if this update is allowed to take place
    let update_allowed = true;

    //sets whether or not we should update the quantity to the available stock level or the stock before the update
    let update_to_available_stock = false;

    //sets whether or not we should show the inline notice for the cart
    let show_cart_inline_notice = true;

    //default to having no quantity for this item currently
    let current_qty = 1;

    //if this ID already exists within the cart
    if(typeof cart[type] !='undefined' && typeof cart[type][id] != 'undefined') {

        //set the current quantity to the existing value
        current_qty = cart[type][id];
    }

    //store the quantity the user has requested
    let requested_qty = quantity;

    //set the total number of tyres to 0 initially
    let tyre_total = 0;

	//if we have a positive quantity
	if(quantity > 0) {

		//if this is an update call for a tyre
		if(type == 'tyres') {

			const is_economy_featured = document.querySelector('.featured-tyre.tyre-item[data-stock_code="' + id + '"][data-type="economy"]') ? true : false;

			//if this is not a featured economy tyre (these are exempt from stock checks)
			if(!is_economy_featured) {

				//check whether or not this stock request is possible
				let stock_level = await stock_lookup(id, quantity);

				//if the stock request isn't possible
				if(stock_level !== true) {

					//attempt to fetch the tyre
					let tyre = document.querySelector('.tyre-item[data-stock_code="' + id + '"], .cart_item[data-stock_code="' + id + '"]');

                    //find our buy button
                    let buy_button = document.querySelector('.tyre-item[data-stock_code="' + id + '"] .buy-now-button');

                    //attempt to find our tyre modal
                    let tyre_modal = document.getElementById('tyre-contact');

                    //if we have a buy now button and tyre modal
                    if(tyre_modal) {

                        //attempt to get our buy now button
                        let tyre_modal_buy_button = tyre_modal.querySelector('.buy-now-button');

                        //if we have a buy now button, we can do everything we need
                        if(tyre_modal_buy_button) {

                            //swap the href with that of our local button (or a hash if we don't have one)
                            tyre_modal_buy_button.href = buy_button ? buy_button.href : '#';

                            //save the product id to the button
                            tyre_modal_buy_button.setAttribute(
                                'data-id',
                                id
                            );

                            //save the product type to the button
                            tyre_modal_buy_button.setAttribute(
                                'data-type',
                                type
                            );

                            //save the starting quantity to the button
                            tyre_modal_buy_button.setAttribute(
                                'data-current_qty',
                                current_qty
                            );

                            //save the requested quantity to the button
                            tyre_modal_buy_button.setAttribute(
                                'data-requested_qty',
                                requested_qty
                            );

                            //save the available quantity to the button
                            tyre_modal_buy_button.setAttribute(
                                'data-available_qty',
                                stock_level
                            );

                            //attempt to find our available stock button
                            let button_text = document.getElementById('available-stock-text');

                            //if we have access to our button
                            if(button_text) {

                                //update the button text, setting the number of tyres available
                                button_text.innerHTML = (button_text.dataset.base).replace('$i', stock_level);
                            }

                            //add our limited stock class to show the message
                            tyre_modal.classList.add('limited-stock');

                            //attempt to find our enquire button
                            let trigger = tyre ? tyre.querySelector('.enquire-button') : false;

                            //trigger the enquiry modal
                            open_enquire(tyre_modal, tyre, (trigger ?? false));

                            //attempt to find the closest quantity indicator (this is last to preserve quantity level when opening modal)
                            let quantity = buy_button ? (buy_button.parentNode.parentNode).querySelector('input.qty') : document.querySelector('#cart input.qty[data-id="' + id + '"]');

                            //if we have access to the quantity indicator
                            if(quantity) {

                                //swap our quantity for the stock level if we're doing that, otherwise set it to the current quantity
                                quantity.value = update_to_available_stock ? stock_level : current_qty;
                            }
                        }
                    }

                    //if we're on the cart page and we're showing the inline notice
                    if(document.body.classList.contains('page-template-page-cart') && show_cart_inline_notice) {

						//attempt to find a notice for this tyre
						let notice = document.querySelector('.available-stock-notice[data-id="' + id + '"]');

						//if we have access to this tyre's notice
						if(notice) {

							//attempt to find our available stock counter
							let available_stock = notice.querySelector('.available-stock');

							//if we have access to our available stock counter
							if(available_stock) {

								//set it with the total number of stock left
								available_stock.innerHTML = stock_level;
							}

							//attempt to find our enquire stock counter
							let enquire_stock = notice.querySelector('.enquire-stock');

							//if we have access to our enquire stock counter
							if(enquire_stock) {

								//fetch the URL of the enquire button
								let url = new URL(enquire_stock.href);

								//strip the query string from the URL
								let stripped_url = url.protocol + "//" + url.hostname + url.pathname;

								//update the URL with the requested quantity
								enquire_stock.href = stripped_url + '?requested_quantity=' + quantity;
							}

							//remove the hidden class, making the space the notice ocupies visible
							notice.classList.remove('hidden');

							//allow this shift to take place
							setTimeout(function() {

								//make it appear
								notice.classList.add('opacity-100');

                                //wait 10s for the user to read the message
                                setTimeout(function() {

                                    //make it disappear
                                    notice.classList.remove('opacity-100');

                                    //wait for the animation to complete
                                    setTimeout(function() {

                                        //restore the space
                                        notice.classList.add('hidden');
                                    }, 300);
                                }, 10000);
							}, 50);
						}
					}

                    //set the quantity to the stock level if we're doing that, otherwise set it to the current quantity
                    quantity = update_to_available_stock ? stock_level : current_qty;

					//indicating this update isn't allowed to take place
					update_allowed =  false;
				}
			}
		}

        //update our total number of tyres
        tyre_total = tyre_total + quantity;

		//if the key doesn't exist, this will be created, otherwise it'll increment the existing one
		cart[type][id] = quantity;
	} else { //otherwise if we have a negative quantity

		//if the product is in the cart and its quantity is more than one
		if(typeof cart[type][id] != 'undefined' && cart[type][id] > 1 && quantity != 0) {

			//update it with the new quantity
			cart[type][id] = quantity;
		} else { //otherwise the element should be removed from the cart

			//delete this product from the cart completely
			delete cart[type][id];
		}
	}

	//update the cart with the new value
	Cookies.set('bt_cart', JSON.stringify(cart), { expires: 1 });

    //if this is the cart page...
    // if(document.body.classList.contains('page-template-page-cart')) {

    //     //fetch the warning element
    //     let warning = document.getElementById('cart-tyre-warning');

    //     //if the warning element exists...
    //     if(warning) {

    //         //if we only have one tyre in the basket...
    //         if(tyre_total === 1) {

    //             //remove the hidden class
    //             warning.classList.remove('hidden');
    //         } else {

    //             //add the hidden class back
    //             warning.classList.add('hidden');
    //         }
    //     }
    // }

    //if this update is allowed to take place
    if(update_allowed) {

        //if this is the cart page
        if(document.body.classList.contains('page-template-page-cart')) {

            //trigger a partial refresh
            cart_partial();
        }

        update_basket_counter();

        //return the new cart value
        return cart;
    } else { //otherwise, this update isn't allowed to take place

        //return false to indicate this
        return false;
    }
}

export function cart_partial() {

	//fetch the cart HTML element
	let cart_html = document.getElementById('cart');

	if(cart_html) {
		toggle_loader(false);

		const xhr = new XMLHttpRequest();
		xhr.addEventListener("readystatechange", function () {


			if (this.readyState === this.DONE) {
				let response = this.responseText;

				//update the HTML with our response
				cart_html.innerHTML = response;
				disable_loader();
			}
		});

		xhr.open("GET", '/wp-json/laserred/cart/partial');
		xhr.setRequestHeader("Accept", "*/*");
		xhr.setRequestHeader("Content-Type", "application/json");

		xhr.send();
	}

}

export function apply_quantities(cart = get_cart()) {

	//attempt to fetch all quantity toggles on the page
	let quantities = document.querySelectorAll('input.qty');

	//if we have some toggles
	if(quantities) {

		//loop over them
		for(let i = 0; i < quantities.length; i++) {

			//if this product exists in the users cart
			if(typeof quantities[i].dataset.id != 'undefined') {

				//loop over each type of product
				['tyres', 'addons'].forEach(product_type => {

					//if this ID is present in the cart
					if(typeof cart[product_type][quantities[i].dataset.id] != 'undefined') {

						//update the current quantity to reflect their selection
						quantities[i].value = cart[product_type][quantities[i].dataset.id];
					}
				});
			}
		}
	}
}

export function get_cart_item_count(cart = get_cart()) {

    //if we have a cart
	if(cart) {

		//figure out how many items are currently in our basket and return this
		return Object.keys(cart.tyres).length + Object.keys(cart.addons).length;
	}

    //otherwise, return 0
    return 0;
}

export function update_basket_counter(count = get_cart_item_count()) {

	//attempt to identify all basket counters that need updating
	let basket_counters = document.getElementsByClassName('basket-counter');

	//if we have a cart total and some basket counters
	if(count && (basket_counters && basket_counters.length > 0)) {

		//loop over the counters
		for(let i = 0; i < basket_counters.length; i++) {

			//update its count
			basket_counters[i].innerHTML = count;
		}
	}
}

export function are_addons_allowed() {

	//see if this page has an addon element
	let addons = document.getElementById('addons');

	//if we have an addons UI
	if(addons) {

		//check whether addons are currently allowed
		let are_addons_allowed = addons.dataset.allowed === 'true';

		//if they're not allowed
		if(!are_addons_allowed) {

			//get the cart
			let cart = get_cart();

			//if we have a cart
			if(cart) {

				//get the ID's of all addons
				let addon_ids = Object.keys(cart.addons);

				//loop over each addon ID
				for(let i = 0; i < addon_ids.length; i++) {

					//remove this from the cart
					update_cart(addon_ids[i], 0, 'addons')
				}
			}
		}
	}
}

document.addEventListener("DOMContentLoaded", function() {

    //if this handler has already been registered
    if(global._cart_initialized) {

        //bail
        return;
    } else { //otherwise this is the first time this handler has been registered

        //indicate this handler has been registered
        global._cart_initialized = true
    }

	//trigger this function on page load
	are_addons_allowed();

	document.addEventListener('click', function (event) {

		if (!event.target.classList.contains('qty-change')) return;

		event.preventDefault();

		//check whether this is the agriculture page
		let agriculture = document.body.classList.contains('term-agriculture');

		//indicates whether the user is on a checkour or cart page as this requires slightly different behaviour
		let checkout_or_cart = document.body.classList.contains('page-template-page-cart') || document.body.classList.contains('page-template-page-checkout');

		//this will be set to true if we're adding an item to the cart or false if we're removing
		let add = event.target.classList.contains('plus');

		//find the intended input we want to update
		let quantity = (event.target.parentNode).querySelector('input.qty');

		//build an integer value of what the user has requested the quantity change to
		let requested_quantity =  (add ? (parseInt(quantity.value) + 1) : (parseInt(quantity.value ) > 1) ? parseInt(quantity.value) - 1 : 0);

		//build a path to the container of this quantity toggle
		let quantity_toggle_container = (event.target).closest('.quantity-toggle').parentNode;

		//attempt to fetch the fulfillment option from the user's cookie, defaulting to branch fitting
		let fulfilment_option = Cookies.get('bt_fulfillment_type') ?? 'branch_fitting';

		//if this isn't agriculture and we have a fulfillment option to use
		if(!agriculture && fulfilment_option) {

			//if the selected fulfilment option is mobile fitting and it's been requested to go lower than our minimum of 2
			if(fulfilment_option == 'mobile_fitting' && requested_quantity <= 1) {

				//replace it to 2
				requested_quantity = 2;
			}
		}

		//if we have a quantity element
		if(quantity) {

			//if this is the cart or checkout page
			if(checkout_or_cart) {

				//update the cart straight away
				update_cart(quantity.dataset.id, requested_quantity, quantity.dataset.type);
			} else { //otherwise, this is a loop page

				//if the quantity has been set to 0
				if(requested_quantity == 0) {

					//replace it with 1, we don't allow them to go to 0 on non-checkout pages
					requested_quantity = 1;
				}
			}

			//update the quantity according to what the user has triggered
			quantity.value = requested_quantity;

            let price_previews = {
                "branch_fitting": (!agriculture ? (quantity_toggle_container.parentNode).querySelector('div[data-type="branch_fitting"] > span') : false),
                "home_delivery": (!agriculture ? (quantity_toggle_container.parentNode).querySelector('div[data-type="home_delivery"] > span') : false),
                "mobile_fitting": (!agriculture ? (quantity_toggle_container.parentNode).querySelector('div[data-type="mobile_fitting"] > span') : false),

                "klarna": (!agriculture ? (quantity_toggle_container.parentNode).querySelector('klarna-placement') : false),
            };

            //loop through each preview
            for (const [type, element] of Object.entries(price_previews)) {

                //if this element is usable
                if(element) {

                    //if this is a klarna widget...
                    if(element.nodeName == 'KLARNA-PLACEMENT') {

                        //attempt to fetch the base amount of our tyre
                        let amount = document.querySelector('#tyre-item-child .tyre-item.is-child-display input[name="delivery-type"]:checked').dataset.base_price;

                        //if we have an amount
                        if(amount) {

                            //multiply our base amount by the quantity
                            amount = amount * requested_quantity;

                            //save this to the OSM widget
                            element.setAttribute('data-purchase-amount', amount);
                        }
                    } else {

                        //parse the price as a float
                        let unit_price = parseFloat(element.dataset.unit_price);

                        //if we have a valid unit price to work with
                        if(unit_price && !isNaN(unit_price)) {

                            //fetch our multibuy prices if available
                            let multibuy_threashold = element.dataset.multibuy_threashhold ? parseInt(element.dataset.multibuy_threashhold) : false;
                            let multibuy_unit_price = element.dataset.unit_multibuy_price ? parseFloat(element.dataset.unit_multibuy_price) : false;

                            //if this is a mobile fitting, we need to account for a minimum of two quantities applied
                            let display_quantity = (type == 'mobile_fitting' && requested_quantity == 1 ? 2 : requested_quantity);

                            //if we have a multibuy threashold and this request meets it
                            if(multibuy_threashold && display_quantity >= multibuy_threashold) {

                                //swap the unit prices
                                unit_price = multibuy_unit_price;
                            }

                            //create our price that we can display in markup
                            let display_price = '£' + (display_quantity * unit_price).toFixed(2);

                            //if the display price contains a decimal point
                            if(display_price.includes('.')) {

                                //replace the decimal point with a small element
                                display_price = display_price.replace('.', '<small class="text-xl">.');

                                //add a closing small element
                                display_price += '</small>';
                            }

                            //set the display price to this calculation
                            element.innerHTML = display_price;
                        }
                    }

                }
            }
		}
	}, false);

	document.addEventListener('click', function (event) {

		if (!event.target.classList.contains('addon-add')) return;

		event.preventDefault();

		let quantity = (event.target.parentNode.parentNode).querySelector('input.qty');

		let allow_update = false;
		let product_id = false;
		let product_quantity = false;

		//if we have a quantity element
		if(quantity) {

			//store the id of this product
			product_id = quantity.dataset.id;

			//update the quantity according to what the user has triggered
			product_quantity = parseInt(quantity.value) + 1;
			quantity.value = product_quantity;

			//indicate we can update the cart
			allow_update = true;
		} else {
			let checkbox = (event.target.parentNode.parentNode).querySelector('input.addon-single');

			//if we have a checkbox
			if(checkbox) {

				//store the id of this product
				product_id = checkbox.dataset.id;

				//update the quantity according to what the user has triggered
				product_quantity = 1;

				//set it as checked
				checkbox.checked = true;

				//indicate we can update the cart
				allow_update = true;
			}
		}

		//if this is the cart or checkout page
		if(document.body.classList.contains('page-template-page-checkout') && allow_update) {

			//update the cart straight away
			update_cart(product_id, product_quantity, "addons");
		}
	}, false);

	document.addEventListener('change', function (event) {

		if (!event.target.classList.contains('qty')) return;

		event.preventDefault();

		let quantity = (event.target.parentNode).querySelector('input.qty');

		//if we have a quantity element
		if(quantity) {

			//if this is the cart or checkout page
			if(document.body.classList.contains('page-template-page-cart') || document.body.classList.contains('page-template-page-checkout')) {

				//update the cart straight away
				update_cart(quantity.dataset.id, quantity.value, quantity.dataset.type);
			}
		}
	}, false);

	document.addEventListener('click', async function (event) {

		if (!event.target.classList.contains('buy-now-button')) return;

		event.preventDefault();

        //define our product ID to false by default
        let product_id = false;

		//save this to a variable so we can swap it if needs be
		let buy_now_button = event.target;

        //default to tyres (this is the default product type)
        let product_type = 'tyres';

        //set the default available quantity to 1
        let available_qty = 1;

        //attempt to find the closest quantity indicator
		let quantity_field = ((buy_now_button).parentNode.parentNode).querySelector('input.qty');

        //if this button has a available quantity
		if(buy_now_button.hasAttribute('data-id')) {

			//fetch the product ID
			product_id = buy_now_button.dataset.id;
		} else if(quantity_field) { //otherwise, if we have a quantity field

            //fetch the product ID from this
            product_id = quantity_field.dataset.id;
        }

        //if this button has a type
		if(buy_now_button.hasAttribute('data-type')) {

			//fetch the product type
			product_type = buy_now_button.getAttribute('data-type');
		} else if(quantity_field) { //otherwise, if we have a quantity field

            //fetch the product type from this
            product_type = quantity_field.dataset.type;
        }

		//if this button has a available quantity
		if(buy_now_button.hasAttribute('data-available_qty')) {

			//fetch the available quantity
			available_qty = parseInt(buy_now_button.dataset.available_qty);
		} else if(quantity_field) { //otherwise, if we have a quantity field

            //fetch the requested quantity from this
            available_qty = quantity_field.value;
        }

		//if we've got the product ID, quantity and type
		if(product_id && available_qty && product_type) {

            //request the update
			let update = await update_cart(product_id, available_qty, product_type);

			//update the cart
			if(update !== false) {

				//redirect the user to the cart
				window.location.href = '/shopping-cart';
			}
		}
	}, false);

	document.addEventListener('click', function (event) {

		if (!event.target.classList.contains('remove-item')) return;

		event.preventDefault();

		//update the cart
		update_cart((event.target).dataset.id, 0);

		//after a few seconds
		setTimeout(function() {

			//check whether addons can be allowed (removed from basket if all tyres are gone)
			are_addons_allowed();
		}, 1500);
	}, false);

	document.addEventListener('click', function (event) {

		if (event.target.classList.contains('checkout-checkbox') || event.target.classList.contains('checkout-checkbox-toggle')) {

			let checkbox = event.target;

			if(event.target.classList.contains('checkout-checkbox-toggle')) {
				checkbox = event.target.previousElementSibling;
			}

			if(checkbox.checked) {
				//update the cart
				update_cart((checkbox).dataset.id, 1, 'addons');
			} else {
				//update the cart
				update_cart((checkbox).dataset.id, 0, 'addons');
			}

		}

	}, false);

	document.addEventListener('click', function (event) {

		if (event.target.classList.contains('available-stock-notice-close')) {

			event.preventDefault();

			//attempt to find the closest notice
			let notice = (event.target).closest('.available-stock-notice');

			//if we have a notice
			if(notice) {

				//make it dissapear
				notice.classList.remove('opacity-100');

				//wait for this to take place
				setTimeout(function() {

					//restore the space
					notice.classList.add('hidden');
				}, 300);

			}
		}

	}, false);

	update_basket_counter();
	apply_quantities();
});